import { API_URL } from '../../../@jumbo/constants/AppConstants';
import React, { useEffect, useState, useCallback } from 'react'; // Aggiunto useCallback
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import Grid from '@material-ui/core/Grid';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/it'; // Importa localizzazione italiana per moment
import 'react-big-calendar/lib/css/react-big-calendar.css'; // Importa CSS base
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useHistory } from 'react-router-dom';
import cogoToast from 'cogo-toast'; // Aggiunto per feedback

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: 'Calendario Eventi', isActive: true }, // Aggiornato label
];

// Imposta la lingua italiana per moment (usata da react-big-calendar)
moment.locale('it');
const localizer = momentLocalizer(moment);

// --- COMPONENTE CUSTOM PER VISUALIZZARE L'EVENTO NEL CALENDARIO ---
const EventComponent = ({ event }) => {
  // Riceve l'intero oggetto evento
  // Stile base per l'evento
  const eventStyle = {
    padding: '2px 5px',
    display: 'block',
    marginBottom: '1px',
    lineHeight: '1.3',
    fontSize: '0.85em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };

  return (
    <div style={eventStyle} title={event.description || event.title}>
      {' '}
      {/* Tooltip con descrizione completa */}      <strong>{event.title}</strong>
      {/* Mostra dettagli diversi in base al tipo */}
      {event.tipo === 'promemoria' && <span style={{ display: 'block', fontSize: '0.9em' }}>(Ordine: {event.oid})</span>}
      {event.tipo !== 'promemoria' && event.description && (
        <span style={{ display: 'block', fontSize: '0.9em' }}>{event.description.substring(0, 50)}...</span>
      )}
         {' '}
    </div>
  );
};

// --- FUNZIONE PER STILE EVENTO (AGGIUNTA CONDIZIONE PER ALLDAY) ---
const eventStyleGetter = (event, start, end, isSelected) => {
  // Colore di base dal backend
  let backgroundColor = event.hexColor ? `#${event.hexColor}` : '#3174ad'; // Default se manca hexColor
  let borderColor = isSelected ? 'black' : backgroundColor; // Bordo nero se selezionato

  // Aggiungi stile per eventi allDay se necessario (es. bordo tratteggiato)
  // if (event.allDay) {
  //   borderColor = 'grey';
  // }

  const style = {
    backgroundColor: backgroundColor,
    borderRadius: '4px', // Smussato
    opacity: 0.9,
    color: '#fff', // Testo bianco per contrasto sulla maggior parte dei colori
    border: `1px solid ${borderColor}`,
    padding: '1px 3px', // Padding interno ridotto
    display: 'block',
    cursor: 'pointer',
    fontSize: '0.8em', // Font più piccolo per più info
    boxShadow: isSelected ? '0px 0px 5px 1px rgba(0,0,0,0.5)' : 'none', // Ombra se selezionato
  };

  // Colore testo scuro per colori chiari (come il giallo dei promemoria)
  if (event.hexColor === 'ffc107') {
    // Se è il colore dei promemoria
    style.color = '#333'; // Testo scuro
  }

  return { style };
};

// --- VISTA AGENDA (OPZIONALE - non modificata) ---
const EventAgenda = ({ event }) => {
  return (
    <span>
            <em>{event.title}</em>      {event.description && <p>{event.description}</p>}   {' '}
    </span>
  );
};

// --- COMPONENTE CALENDARIO PRINCIPALE ---
const Calendario = props => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true); // Stato di caricamento
  const history = useHistory();

  // --- GESTORE CLICK SU EVENTO (MODIFICATO) ---
  const handleSelected = useCallback(
    event => {
      console.info('[handleSelected - event]', event);
      // Naviga in base al tipo di evento
      if (event.tipo === 'promemoria') {
        // Se è un promemoria, vai all'ordine associato
        if (event.oid) {
          history.push(`/ordine/${event.oid}`); // *** ADATTA IL PERCORSO SE NECESSARIO ***
        } else {
          cogoToast.info('Questo promemoria non è associato a un ordine specifico.');
        }
      } else if (event.tipo === '0') {
        // Assumendo '0' per Offerta Interventi
        history.push(`/offerta-interventi/${event.oid}`); // *** ADATTA IL PERCORSO SE NECESSARIO ***
      } else if (event.tipo === '1') {
        // Assumendo '1' per Ordine Interventi (o altro tipo)
        history.push(`/ordine-interventi/${event.oid}`); // *** ADATTA IL PERCORSO SE NECESSARIO ***
      } else {
        // Gestisci altri tipi o eventi senza 'tipo' definito
        cogoToast.info(`Evento selezionato: ${event.title}`);
      }
    },
    [history],
  ); // Dipende da history

  // --- FUNZIONE PER CARICARE GLI EVENTI (CON ROBUSTEZZA DATE) ---
  const fetchEvents = useCallback(() => {
    setLoading(true);
    fetch(API_URL + '/getEvents.php', {
      method: 'get',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(risp => {
        if (risp.success && Array.isArray(risp.eventi)) {
          const processedEvents = risp.eventi
            .map(event => {
              // Tenta di convertire start e end in Date objects
              // Gestisce sia stringhe ISO 8601 che 'YYYY-MM-DD'
              const start = moment(event.start).toDate(); // Usa moment per parsing più robusto
              // Per 'end', se è allDay, RBC potrebbe non richiederlo strettamente,
              // ma impostarlo allo stesso giorno per sicurezza non fa male.
              // Se non è allDay, deve essere una data valida.
              const end = event.end ? moment(event.end).toDate() : start;

              // Verifica se le date sono valide dopo la conversione
              if (isNaN(start.getTime())) {
                console.warn("Data 'start' non valida per l'evento:", event);
                return null; // Salta questo evento se la data start non è valida
              }
              if (!event.allDay && isNaN(end.getTime())) {
                console.warn("Data 'end' non valida per l'evento non allDay:", event);
                return null; // Salta evento non allDay con end non valido
              }

              return {
                ...event, // Mantiene tutte le altre proprietà (tipo, oid, hexColor, etc.)
                start: start,
                end: event.allDay ? start : end, // Usa start come end per allDay
              };
            })
            .filter(event => event !== null); // Rimuovi eventi con date non valide

          // console.log('Eventi processati:', processedEvents);
          setEvents(processedEvents);
        } else {
          cogoToast.error('Errore nel caricamento eventi: ' + (risp.message || 'Formato dati non valido'));
          setEvents([]); // Resetta a array vuoto in caso di errore
        }
      })
      .catch(error => {
        console.error('Fetch error:', error);
        cogoToast.error('Errore di rete durante il caricamento degli eventi.');
        setEvents([]);
      })
      .finally(() => {
        setLoading(false); // Nascondi caricamento
      });
  }, []); // useCallback con dipendenze vuote

  // --- EFFETTO PER CARICARE EVENTI AL MOUNT ---
  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]); // Chiama fetchEvents al mount

  return (
    <PageContainer heading={'Calendario Eventi e Promemoria'} breadcrumbs={breadcrumbs}>
           {' '}
      <GridContainer>
               {' '}
        <Grid item xs={12}>
          {loading && <p>Caricamento calendario...</p>}
          {!loading && (
            <Calendar
              style={{ height: 700 }} // Altezza calendario
              localizer={localizer} // Localizer basato su moment
              culture="it" // Cultura italiana per date e label
              events={events} // Array di eventi (include promemoria)
              startAccessor="start" // Campo per data inizio
              endAccessor="end" // Campo per data fine
              allDayAccessor="allDay" // Campo per eventi all-day
              // --- Event Handlers ---
              onSelectEvent={handleSelected} // Funzione chiamata al click su un evento
              // onSelectSlot={handleSelectSlot} // Funzione per click/drag su slot vuoti (opzionale)
              // onView={handleViewChange} // Funzione al cambio vista (mese/settimana/giorno) (opzionale)
              // onNavigate={handleNavigate} // Funzione al cambio data (mese/settimana/giorno precedente/successivo) (opzionale)

              // --- Personalizzazione UI ---
              messages={{
                // Testi per i pulsanti e label
                today: 'Oggi',
                previous: <ArrowBackIcon />,
                next: <ArrowForwardIcon />,
                month: 'Mese',
                week: 'Settimana',
                day: 'Giorno',
                agenda: 'Agenda',
                date: 'Data',
                time: 'Ora',
                event: 'Evento', // Label nella vista Agenda
                noEventsInRange: 'Nessun evento in questo periodo.', // Messaggio se non ci sono eventi
              }}
              components={{
                // Componenti custom per rendering
                event: EventComponent, // Componente per evento nelle viste mese/settimana/giorno
                agenda: {
                  event: EventAgenda, // Componente per evento nella vista Agenda
                },
              }}
              eventPropGetter={eventStyleGetter} // Funzione per applicare stili dinamici agli eventi
              selectable={true} // Permette di selezionare slot vuoti (se gestito da onSelectSlot)
              popup={true} // Mostra eventi sovrapposti in un popup nella vista mese
              views={['month', 'week', 'day', 'agenda']} // Viste disponibili
            />
          )}
                 {' '}
        </Grid>
             {' '}
      </GridContainer>
         {' '}
    </PageContainer>
  );
};

export default Calendario;
